import { InjectionToken } from '@angular/core';

/**
 * Dynamic form service token. Used instead of simple injection, because 'inject' function fall with error in field-type-base.ts
 */
export const DYNAMIC_FORM_DOC = new InjectionToken('docControl');
